import { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";

type Props = {
  totalRecords: number,
  pageLimit: number,
  pageNeighbours: number,
  onPageChanged: Function,
  currentPage: number,
  maxPages?: number
}

export default function CustomPagination(props: Props) {
  const { pageNeighbours, maxPages = undefined } = props;
  const [totalPages, setTotalPages] = useState<number>(0);
  const [arrowsNeighbours, setArrowsNeighbours] = useState<number>(0);
  const [isMount, setIsMount] = useState<boolean>(false);
  const { onPageChanged, currentPage } = props;

  useEffect(() => {

    const pageLimit =
      typeof props.pageLimit === 'number' ? props.pageLimit : 25;
    const totalRecords =
      typeof props.totalRecords === 'number' ? props.totalRecords : 0;

    const arrowsNeighbours =
      typeof pageNeighbours === 'number'
        ? Math.max(0, Math.min(pageNeighbours, 2))
        : 5;

    let totalPages = Math.ceil(totalRecords / pageLimit);

    if (maxPages !== undefined) {
      totalPages = totalPages > maxPages ? maxPages : totalPages;
    }

    setTotalPages(totalPages);
    setArrowsNeighbours(arrowsNeighbours);

    if (!isMount) {
      setIsMount(true);
    }
  }, [props, isMount, setIsMount, pageNeighbours, maxPages]);

  function goToPage(page: number): void {

    let newPage = Math.max(0, Math.min(page, totalPages));

    if (newPage < 1) {
      newPage = 1;
    }

    if (newPage > totalPages) {
      newPage = totalPages;
    }

    onPageChanged(newPage, totalPages);
  };

  function getPaginationItems(
    first: number,
    last: number,
    type: 'prev' | 'next'
  ) {
    if (first < 2) {
      first = 2;
    }

    if (last >= totalPages) {
      last = totalPages - 1;
    }

    let pages = [];

    for (let i = first; i <= last; i++) {
      pages.push(i);
    }

    return pages.length ? pages.map((page: number, index: number) => {
      return <Pagination.Item
        key={index}
        className={`page-item-${type}`}
        onClick={() => goToPage(page)}
      >
        {page}
      </Pagination.Item>
    }) : <></>
  }

  return <Pagination>
    {currentPage > 1 ? <>
      <Pagination.First
        className="page-first"
        disabled={currentPage === 1}
        onClick={() => goToPage(1)}
      >1</Pagination.First>
      {(currentPage > ((pageNeighbours * 2) + 1))
        ? <Pagination.Prev
          className="page-prev"
          onClick={() => goToPage(currentPage - pageNeighbours * 2)}
        >
          {/* {currentPage - pageNeighbours * 2} */}
        </Pagination.Prev>
        : <></>
      }
      <Pagination.Ellipsis className="page-prev-ellipsis" />
    </> : <></>}
    {getPaginationItems(currentPage - arrowsNeighbours, currentPage - 1, 'prev')}
    <Pagination.Item className="page-active" active>{currentPage}</Pagination.Item>
    {getPaginationItems(currentPage + 1, currentPage + arrowsNeighbours, 'next')}
    {currentPage < totalPages ? <>
      <Pagination.Ellipsis className="page-next-ellipsis" />
      {(currentPage + (pageNeighbours * 2)) < totalPages
        ? <Pagination.Next
          className="page-next"
          onClick={() => goToPage(currentPage + (pageNeighbours * 2))}
        >
          {/* {currentPage + (pageNeighbours * 2)} */}
        </Pagination.Next>
        : <></>
      }
      <Pagination.Last
        className="page-last"
        disabled={currentPage === totalPages}
        onClick={() => goToPage(totalPages)}
      >{totalPages}</Pagination.Last>
    </> : <></>}
  </Pagination>
}